import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { LOGO_HEIGHT, LOGO_URL, LOGO_WIDTH } from '@/lib/brand';

const CONTACT_EMAIL = 'calendar@togaphotos.com';

/* Colophon above the page end: wordmark and tagline, site links, contact and copyright. */
export function Footer() {
  const { t } = useTranslation('public');
  return (
    <footer className="global-container mt-12 border-t border-rule pb-12 pt-6 text-xs text-ink-2">
      <div className="grid gap-6 md:grid-cols-12 md:gap-x-6">
        <div className="flex flex-col gap-2 md:col-span-5">
          <Link to="/" className="block w-fit" aria-label="TOGAPhotos">
            <img
              src={LOGO_URL}
              width={LOGO_WIDTH}
              height={LOGO_HEIGHT}
              alt="TOGAPhotos"
              className="block w-40 select-none"
              loading="lazy"
              decoding="async"
            />
          </Link>
          <p className="m-0 max-w-[40ch] leading-relaxed">{t('footer.tagline')}</p>
        </div>
        <nav aria-label={t('footer.siteLinks')} className="kicker flex flex-col gap-1.5 md:col-span-3 md:col-start-7">
          <Link to="/" className="min-h-6 w-fit text-ink-2 hover:text-ink">{t('nav.home')}</Link>
          <Link to="/calendar" className="min-h-6 w-fit text-ink-2 hover:text-ink">{t('nav.calendar')}</Link>
          <a
            href="https://togaphotos.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="min-h-6 w-fit text-ink-2 hover:text-ink"
          >
            {t('footer.mainSite')}
          </a>
        </nav>
        <div className="kicker flex flex-col gap-1.5 md:col-span-3">
          <span>{t('about.contact')}</span>
          <a href={`mailto:${CONTACT_EMAIL}`} className="min-h-6 w-fit normal-case tracking-normal text-ink hover:text-accent-text">
            {CONTACT_EMAIL}
          </a>
          <span className="mt-2 font-mono normal-case tracking-[0.04em]">{t('footer.copyright')}</span>
        </div>
      </div>
    </footer>
  );
}
